class StorageHelper {
  static AUTH_KEYS = [
    'UserData', 
    'isLoggedIn', 
    'auth_token', 
    'email', 
    'mobile', 
    'jwt', 
    'categories_with_sub_categories'
  ];

  static clearAuthDataOnly() {
    try {      
      
      this.AUTH_KEYS.forEach(key => {
        localStorage.removeItem(key);
      });
      
      localStorage.setItem('isLoggedIn', false);
      setTimeout(() => {
        window.location.href = "/";
      }, 800);
      
      return true;
    } catch (error) {
      return false;
    }
  }

}

export default StorageHelper;
